export const CalculatorKeys = {
	all: ["calculator"] as const,
	dashboardPermissions: () =>
		[...CalculatorKeys.all, "dashboardPermissions"] as const,
	mortgageRates: () => [...CalculatorKeys.all, "mortgageRates"] as const,
};
